import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
import { defineComponent as _defineComponent } from 'vue';
import { toNumber } from 'lodash';
import { useShowDebugging } from '~/functions/accounts';
import { getLocale } from '~/functions/translate';
import { validateUrl } from '~/functions/helpers';
import { AccountCategory, useGetAccountQuery, useGetQuestionnaireQuery, useUpdateAccountMutation, useUpdateQuestionnaireNavigationMutation } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: '_questionnaire',
  setup: function setup(__props, _ref) {
    var expose = _ref.expose;
    var route = useRoute();
    var questionnaireId = computed(function () {
      return toNumber(route.params.questionnaire);
    });
    var ventureId = computed(function () {
      return route.params.venture;
    });
    var _useGetAccountQuery = useGetAccountQuery(),
      accountResult = _useGetAccountQuery.result;
    var showDebugging = useShowDebugging();
    var account = computed(function () {
      var _accountResult$value$, _accountResult$value;
      return (_accountResult$value$ = (_accountResult$value = accountResult.value) === null || _accountResult$value === void 0 ? void 0 : _accountResult$value.getAccount) !== null && _accountResult$value$ !== void 0 ? _accountResult$value$ : {
        name: '',
        website: '',
        logo: '',
        type: AccountCategory.Portfolio
      };
    });
    var accountVentureQueryResult = null;
    var accountVenture = computed(function () {
      if (account.value.type === AccountCategory.Venture) {
        return account.value;
      } else {
        var _accountVentureQueryR;
        if (!accountVentureQueryResult) {
          accountVentureQueryResult = useGetAccountQuery({
            id: ventureId
          });
        }
        return (_accountVentureQueryR = accountVentureQueryResult.result.value) === null || _accountVentureQueryR === void 0 ? void 0 : _accountVentureQueryR.getAccount;
      }
    });
    var esgActionsActive = computed(function () {
      var _accountVenture$value;
      return ((_accountVenture$value = accountVenture.value) === null || _accountVenture$value === void 0 ? void 0 : _accountVenture$value.esgActionsActive) === true;
    });
    var _useUpdateAccountMuta = useUpdateAccountMutation(),
      updateAccount = _useUpdateAccountMuta.mutate,
      onDone = _useUpdateAccountMuta.onDone;
    onDone(function () {
      window.$nuxt.$emit('userMsg');
    });
    var triggerUpdateAccount = function triggerUpdateAccount(key, val) {
      updateAccount({
        input: _defineProperty({
          id: ventureId.value
        }, key, val)
      });
    };
    var _useGetQuestionnaireQ = useGetQuestionnaireQuery({
        id: questionnaireId.value
      }),
      result = _useGetQuestionnaireQ.result,
      loading = _useGetQuestionnaireQ.loading;
    var questionnaire = computed(function () {
      var _result$value;
      return (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.getQuestionnaire;
    });
    var questionnaireTemplate = computed(function () {
      var _questionnaire$value, _questionnaire$value$, _questionnaire$value2, _questionnaire$value3;
      // Take the second level of the sections because the "company" level carries no useful information.
      if (!(questionnaire !== null && questionnaire !== void 0 && (_questionnaire$value = questionnaire.value) !== null && _questionnaire$value !== void 0 && (_questionnaire$value$ = _questionnaire$value.questionnaireTemplate) !== null && _questionnaire$value$ !== void 0 && _questionnaire$value$.sections)) return null;
      return questionnaire === null || questionnaire === void 0 ? void 0 : (_questionnaire$value2 = questionnaire.value) === null || _questionnaire$value2 === void 0 ? void 0 : (_questionnaire$value3 = _questionnaire$value2.questionnaireTemplate) === null || _questionnaire$value3 === void 0 ? void 0 : _questionnaire$value3.sections[0];
    });
    var questionnaireAssignment = computed(function () {
      var _questionnaire$value4, _questionnaire$value5;
      if (!(questionnaire !== null && questionnaire !== void 0 && (_questionnaire$value4 = questionnaire.value) !== null && _questionnaire$value4 !== void 0 && _questionnaire$value4.questionnaireAssignment)) return null;
      return questionnaire === null || questionnaire === void 0 ? void 0 : (_questionnaire$value5 = questionnaire.value) === null || _questionnaire$value5 === void 0 ? void 0 : _questionnaire$value5.questionnaireAssignment;
    });
    var questionnaireNavigation = computed(function () {
      var _questionnaire$value6, _questionnaire$value7;
      if (!(questionnaire !== null && questionnaire !== void 0 && (_questionnaire$value6 = questionnaire.value) !== null && _questionnaire$value6 !== void 0 && _questionnaire$value6.questionnaireNavigation)) return null;
      return questionnaire === null || questionnaire === void 0 ? void 0 : (_questionnaire$value7 = questionnaire.value) === null || _questionnaire$value7 === void 0 ? void 0 : _questionnaire$value7.questionnaireNavigation;
    });
    var sectionCompletionMapping = computed(function () {
      var _questionnaire$value8, _questionnaire$value9;
      if (!questionnaire.value || !questionnaire.value.questionnaireAssignment) return {};
      return Object.assign.apply(Object, [{}].concat(_toConsumableArray((_questionnaire$value8 = questionnaire.value) === null || _questionnaire$value8 === void 0 ? void 0 : (_questionnaire$value9 = _questionnaire$value8.questionnaireAssignment) === null || _questionnaire$value9 === void 0 ? void 0 : _questionnaire$value9.sectionCompletion.map(function (x) {
        return _defineProperty({}, x.sectionId, x);
      }))));
    });
    var userInputMapping = computed(function () {
      var _questionnaireAssignm, _questionnaireAssignm2;
      if ((questionnaireAssignment === null || questionnaireAssignment === void 0 ? void 0 : (_questionnaireAssignm = questionnaireAssignment.value) === null || _questionnaireAssignm === void 0 ? void 0 : (_questionnaireAssignm2 = _questionnaireAssignm.userInputs) === null || _questionnaireAssignm2 === void 0 ? void 0 : _questionnaireAssignm2.length) > 0) {
        var _questionnaireAssignm3;
        return Object.assign.apply(Object, [{}].concat(_toConsumableArray(questionnaireAssignment === null || questionnaireAssignment === void 0 ? void 0 : (_questionnaireAssignm3 = questionnaireAssignment.value) === null || _questionnaireAssignm3 === void 0 ? void 0 : _questionnaireAssignm3.userInputs.map(function (x) {
          return _defineProperty({}, String(x.question.id), x);
        }))));
      }
      return {};
    });
    var _useUpdateQuestionnai = useUpdateQuestionnaireNavigationMutation(),
      updateQuestionnaireNavigation = _useUpdateQuestionnai.mutate;
    var currentSectionId = computed(function () {
      var _questionnaireNavigat;
      return questionnaireNavigation === null || questionnaireNavigation === void 0 ? void 0 : (_questionnaireNavigat = questionnaireNavigation.value) === null || _questionnaireNavigat === void 0 ? void 0 : _questionnaireNavigat.currentSubsection;
    });
    var currentSection = computed(function () {
      if (questionnaireTemplate.value) {
        return questionnaireTemplate.value.sections.find(function (e) {
          return e.id === currentSectionId.value;
        });
      }
      return {
        ixId: ''
      };
    });
    function navigateSection(direction) {
      var _questionnaireTemplat, _questionnaireTemplat2, _questionnaire$value10, _questionnaire$value11;
      var sections = (_questionnaireTemplat = (_questionnaireTemplat2 = questionnaireTemplate.value) === null || _questionnaireTemplat2 === void 0 ? void 0 : _questionnaireTemplat2.sections) !== null && _questionnaireTemplat !== void 0 ? _questionnaireTemplat : [];
      var currentIndex = sections.findIndex(function (section) {
        return section.id === currentSectionId.value;
      });
      if (currentIndex === -1) return;
      var offset = direction === 'next' ? 1 : -1;
      var targetIndex = currentIndex + offset;
      if (targetIndex < 0 || targetIndex >= sections.length) return;
      var assignmentId = (_questionnaire$value10 = questionnaire.value) === null || _questionnaire$value10 === void 0 ? void 0 : (_questionnaire$value11 = _questionnaire$value10.questionnaireAssignment) === null || _questionnaire$value11 === void 0 ? void 0 : _questionnaire$value11.id;
      if (typeof assignmentId === 'number') {
        updateQuestionnaireNavigation({
          input: {
            id: assignmentId,
            currentSection: 1,
            currentSubsection: sections[targetIndex].id
          }
        });
      }
    }
    var onSectionSelect = function onSectionSelect(item) {
      if (item.length !== 0) {
        var _questionnaire$value12, _questionnaire$value13;
        updateQuestionnaireNavigation({
          input: {
            id: questionnaire === null || questionnaire === void 0 ? void 0 : (_questionnaire$value12 = questionnaire.value) === null || _questionnaire$value12 === void 0 ? void 0 : (_questionnaire$value13 = _questionnaire$value12.questionnaireAssignment) === null || _questionnaire$value13 === void 0 ? void 0 : _questionnaire$value13.id,
            currentSection: 1,
            currentSubsection: item[0].id
          }
        });
      }
    };
    var formatDebugData = function formatDebugData(data) {
      return JSON.stringify(data, null, 2).replace(/"([^"]+)":/g, '$1:') // Remove quotes around keys
      .replace(/[{},]/g, '') // Remove brackets and commas
      .trim(); // Remove extra whitespace
    };
    var hasOtherBusinessModel = computed(function () {
      var _userInputMapping$val, _userInputMapping$val2, _userInputMapping$val3;
      // one of the selected options ids must be 207
      return (_userInputMapping$val = (_userInputMapping$val2 = userInputMapping.value[11]) === null || _userInputMapping$val2 === void 0 ? void 0 : (_userInputMapping$val3 = _userInputMapping$val2.selectedOptions) === null || _userInputMapping$val3 === void 0 ? void 0 : _userInputMapping$val3.some(function (option) {
        return option.id === 207;
      })) !== null && _userInputMapping$val !== void 0 ? _userInputMapping$val : false;
    });
    var hasOtherIncomeStream = computed(function () {
      var _userInputMapping$val4, _userInputMapping$val5, _userInputMapping$val6;
      return (_userInputMapping$val4 = (_userInputMapping$val5 = userInputMapping.value[12]) === null || _userInputMapping$val5 === void 0 ? void 0 : (_userInputMapping$val6 = _userInputMapping$val5.selectedOptions) === null || _userInputMapping$val6 === void 0 ? void 0 : _userInputMapping$val6.some(function (option) {
        return option.id === 31;
      })) !== null && _userInputMapping$val4 !== void 0 ? _userInputMapping$val4 : false;
    });
    var hasOtherCustomerGroup = computed(function () {
      var _userInputMapping$val7, _userInputMapping$val8, _userInputMapping$val9;
      return (_userInputMapping$val7 = (_userInputMapping$val8 = userInputMapping.value[2786]) === null || _userInputMapping$val8 === void 0 ? void 0 : (_userInputMapping$val9 = _userInputMapping$val8.selectedOptions) === null || _userInputMapping$val9 === void 0 ? void 0 : _userInputMapping$val9.some(function (option) {
        return option.id === 16008;
      })) !== null && _userInputMapping$val7 !== void 0 ? _userInputMapping$val7 : false;
    });
    var shouldShowQuestion = function shouldShowQuestion(questionId) {
      if (questionId === 79) return hasOtherBusinessModel.value;
      if (questionId === 80) return hasOtherIncomeStream.value;
      if (questionId === 18) return hasOtherCustomerGroup.value;
      return true;
    };
    var questionnaireComplete = computed(function () {
      return Object.values(sectionCompletionMapping.value).every(function (section) {
        return section.isCompleted;
      });
    });
    var locale = getLocale();
    var sectionIdNameMapping = {
      6: locale === 'en' ? 'Basic Information' : 'Grundlegende Informationen',
      7: locale === 'en' ? 'Additional Context Information' : 'Zusätzliche Kontextinformationen'
    };
    var incompleteItems = computed(function () {
      // 1. Filter out incomplete sections (excluding sectionId === 1).
      var incompleteSections = Object.values(sectionCompletionMapping.value).filter(function (section) {
        return !section.isCompleted && section.sectionId !== 1;
      });

      // 2. “Flatten” by mapping each section’s incomplete questions into
      //    an array of { question, section } objects.
      return incompleteSections.flatMap(function (section) {
        var sectionName = sectionIdNameMapping[section.sectionId];
        return section.incompleteQuestions.map(function (question) {
          return {
            question: question,
            section: sectionName
          };
        });
      });
    });
    expose({
      // expose any methods if needed for parent components
    });
    return {
      __sfc: true,
      route: route,
      questionnaireId: questionnaireId,
      ventureId: ventureId,
      accountResult: accountResult,
      showDebugging: showDebugging,
      account: account,
      accountVentureQueryResult: accountVentureQueryResult,
      accountVenture: accountVenture,
      esgActionsActive: esgActionsActive,
      updateAccount: updateAccount,
      onDone: onDone,
      triggerUpdateAccount: triggerUpdateAccount,
      result: result,
      loading: loading,
      questionnaire: questionnaire,
      questionnaireTemplate: questionnaireTemplate,
      questionnaireAssignment: questionnaireAssignment,
      questionnaireNavigation: questionnaireNavigation,
      sectionCompletionMapping: sectionCompletionMapping,
      userInputMapping: userInputMapping,
      updateQuestionnaireNavigation: updateQuestionnaireNavigation,
      currentSectionId: currentSectionId,
      currentSection: currentSection,
      navigateSection: navigateSection,
      onSectionSelect: onSectionSelect,
      formatDebugData: formatDebugData,
      hasOtherBusinessModel: hasOtherBusinessModel,
      hasOtherIncomeStream: hasOtherIncomeStream,
      hasOtherCustomerGroup: hasOtherCustomerGroup,
      shouldShowQuestion: shouldShowQuestion,
      questionnaireComplete: questionnaireComplete,
      locale: locale,
      sectionIdNameMapping: sectionIdNameMapping,
      incompleteItems: incompleteItems,
      validateUrl: validateUrl
    };
  }
});